__turbopack_context__.v({
  "container": "gims3G_container",
  "divider": "gims3G_divider",
  "item": "gims3G_item",
});
